/**
 * QueryClient único del Admin (T030): `retry` 1 y `staleTime` 10 s.
 * Un error 4xx del catálogo (`contracts/errors.md`) no se reintenta: la respuesta no va a cambiar.
 */
import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './client';

export const QUERY_STALE_TIME_MS = 10_000;
export const QUERY_RETRY = 1;

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status < 500) {
    return false;
  }
  return failureCount < QUERY_RETRY;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: QUERY_STALE_TIME_MS,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export const queryClient = createQueryClient();
